<template>
  <div class="table-container">
    <button class="button hot-list-button"  @click="saveTableToDb">首选入库</button>
    <div class="table-wrapper">
      <table class="copyable-table">
        <caption>{{ responseData.title }}</caption>
        <thead>
          <tr>
            <th><input type="checkbox" @click="toggleSelectAll">全选</th>
            <th v-for="(header, key) in headers" :key="key" @click="sortData(key)">
              {{ header }}
            </th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in sortedData" :key="rowIndex" :class="rowClasses(row)">
            <td><input type="checkbox" :value="rowIndex" v-model="selectedStocks"></td>
            <td v-for="(value, key) in row" :key="key" :class="cellClasses(value)">
              {{ formatValue(value) }}
            </td>
            <td>
              <a href="#" @click="handleOnPrice(row)">报价</a>
              <br/>
              <a href="#" @click="handleOnLine(row)">雪球</a>
              <br/>
               <a href="#" @click="handleOnFHPS(row)">分红</a>
              <br/>
              <a href="#" @click="handleWenCai(row)">问财</a>
              <br/>
              <a href="#" @click="handleLHB(row)">龙虎榜</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { copyTableToImage } from '@/utils/utils';
import { onPrice, onLine, onWenCai, onLHB,onFHPS} from '@/utils/commonMethods';
import axios from 'axios';

export default {
  props: {
    responseData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      sortKey: '',
      sortOrder: 'asc',
      currentDate: new Date().toLocaleDateString(),
      selectedStocks: []
    };
  },
  computed: {
    headers() {
      return this.responseData.headers || [];
    },
    sortedData() {
      const dataCopy = this.responseData.data && Array.isArray(this.responseData.data)
        ? JSON.parse(JSON.stringify(this.responseData.data))
        : [];

      if (!this.sortKey) return dataCopy;

      return dataCopy.sort((a, b) => {
        const aValue = a[this.sortKey] || '';
        const bValue = b[this.sortKey] || '';

        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return this.sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        }

        if (aValue < bValue) return this.sortOrder === 'asc' ? -1 : 1;
        if (aValue > bValue) return this.sortOrder === 'asc' ? 1 : -1;
        return 0;
      });
    }
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined) return '--';
      if (typeof value === 'number') {
        return value.toFixed(2);
      }
      if (value instanceof Date) {
        return value.toLocaleDateString();
      }
      return value;
    },

    toggleSelectAll() {
      if (this.selectedStocks.length === this.sortedData.length) {
        this.selectedStocks = [];
      } else {
        this.selectedStocks = this.sortedData.map((row, index) => index);
      }
    },

    getSelectedStocks() {
      return this.selectedStocks;
    },

    saveTableToDb() {
      const selectedStocks = this.getSelectedStocks();
      const thirdColumnData = [];

      selectedStocks.forEach(rowIndex => {
        const row = this.sortedData[rowIndex];

        if (row && Array.isArray(row) && row.length >= 15) {
          thirdColumnData.push([row[1], row[2], row[3], row[7], row[10], row[12], row[13], row[14]]);
        }
      });

      if (thirdColumnData.length > 0) {
        axios.post('/api/save', { data: thirdColumnData })
          .then(response => {
            console.log('Data saved successfully:', response.message);
            alert('数据保存成功！');
          })
          .catch(error => {
            console.error('Error saving data:', error);
          });
      } else {
        console.log('No data to save.');
      }
    },

    sortData(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },

    handleOnPrice(row) {
      onPrice(this.responseData, row, this.$router);
    },

    handleOnLine(row) {
      onLine(this.responseData, row);
    },

    handleWenCai(row) {
      onWenCai(this.responseData, row);
    },

    handleLHB(row) {
      onLHB(this.responseData, row, this.$router);
    },
    handleOnFHPS(row) {
      onFHPS(this.responseData, row, this.$router);
    },

    copyTableToImage() {
      const table = this.$el.querySelector('table');
      const fileName = '个股涨停情况_' + this.currentDate + '.png';
      copyTableToImage(table, fileName);
    },

    shouldHighlightRow(row) {
      const conditions = ['首板涨停', '缩量涨停'];

      // 如果是对象类型，检查所有字段值
      return conditions.every(condition =>
        Object.values(row).some(value =>
          String(value).includes(condition)
        )
      );
    },

    rowClasses(row) {
      return {
        'highlight-row': this.shouldHighlightRow(row)
      };
    },

    cellClasses(value) {
      const keywords = ['量化基金', '小鳄鱼', '炒股养家', '缩量涨停', '首板涨停'];
      return {
        'text-red': keywords.some(keyword => String(value).includes(keyword))
      };
    }
  }
};
</script>

<style scoped>
@import '../assets/css/ChildComponent.css';

.process-data-button {
  background-color: #007bff; /* 蓝色 */
}

.update-stock-button {
  background-color: #28a745; /* 绿色 */
}

.hot-list-button {
  background-color: #dc3545; /* 红色 */
}

.text-list-button {
  background-color: #ffc107; /* 橙色 */
}

.etf-list-button {
  background-color: #6c757d; /* 灰色 */
}

.first-time-button {
  background-color: #007bff; /* 蓝色 */
}

.day-search-button {
  background-color: #28a745; /* 绿色 */
}

.export2db-button {
  background-color: #dc3545; /* 红色 */
}

.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.copyable-table {
  min-width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.copyable-table th,
.copyable-table td {
  padding: 0.5rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  white-space: nowrap;
}

.copyable-table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.copyable-table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.highlight-row {
  background-color: #fff3cd !important;
}

.text-red {
  color: #dc3545;
  font-weight: bold;
}
</style>
